module.exports = __webpack_public_path__ + "media/images/instagram-9cf4f16e82619b46d320de15093a99f1.png";